import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import * as Utils from '@core/utils';
import { Observable } from 'rxjs';
import { getCookie } from '@core/utils';
import { CNAME } from '@core/constants/cookies';
import { SNAME } from '@core/constants/storage';
import { WebAuthNVerificationRequest } from '@api/model/webAuthNVerificationRequest';
import { WebAuthnVerificationAction } from '@api/index';

const isTokenEndpoint = (url: string, method: string): boolean => {
  return method.toUpperCase() === 'POST' && /\/v1\/token(\?|$)/.test(url);
};

@Injectable()
export class AuthHeaderInterceptor implements HttpInterceptor {
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Adding this check because we need pass different token base on webauth type
    // WebAuthnVerificationAction => Register || Authenticate
    if (httpRequest.url.includes('verify-webauthn')) {
      console.log(httpRequest.body);
      return next.handle(
        httpRequest.clone({
          setHeaders: {
            Authorization: `Bearer ${httpRequest.body.verification_action === WebAuthnVerificationAction.Authenticate
                ? localStorage.getItem(SNAME.USER_JWS)
                : Utils.getCookie(CNAME.PBB_UI_TOKEN) || ''
              }`,
          },
        })
      );
    }
    if (httpRequest.url.includes('login-id') && httpRequest.url.includes('verify')) {
      console.log(httpRequest.body);
      return next.handle(
        httpRequest.clone({
          setHeaders: {
            Authorization: `Bearer ${httpRequest.body.verification_action === WebAuthnVerificationAction.Authenticate
              ? localStorage.getItem(SNAME.USER_JWS)
              : Utils.getCookie(CNAME.PBB_UI_TOKEN) || ''
              }`,
          },
        })
      );
    }
    // Token exchange should not include Authorization; DPoP proof is set by DpopInterceptor.
    if (isTokenEndpoint(httpRequest.url, httpRequest.method)) {
      return next.handle(httpRequest);
    }

    if (
      httpRequest.headers.get('Authorization') ||
      (httpRequest.url.includes('financial-institution') && httpRequest.method === 'GET') ||
      httpRequest.url.includes('pilot-otc')
    ) {
      return next.handle(httpRequest);
    }
    return next.handle(
      httpRequest.clone({
        setHeaders: {
          Authorization: `Bearer ${getCookie(CNAME.PBB_UI_TOKEN) || ''}`,
        },
      })
    );
  }
}
